/*
@author: Eligijus Skersonas
*/

import React, { Component } from "react";
import NavigationBar from './navbar';

class Header extends Component {

  render() {
    return (<NavigationBar/>);
  }
}

export default Header;
